import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.8 8.1l-7-4.7c-.8-.5-1.8-.5-2.6 0L1.3 8.1c-.2.2-.3.5-.1.7s.5.3.7.1L3 8.1V16c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V8.1l1.2.8c.1.1.2.1.3.1.2 0 .3-.1.4-.2.2-.2.1-.6-.1-.7zM7 17v-4c0-.6.4-1 1-1h3c.6 0 1 .4 1 1v4H7z',
  ],
  height: 20,
  width: 20,
});
